{
  "salon-visited-page": {
    "buttons": {
      "book-appointment": "ĐẶT LỊCH"
    },
    "text": {
      "no-visited-salon": "Không thể tìm thấy tiệm đã ghé thăm",
      "promotional-message": "Tin nhắn quảng cáo",
      "visited-salon": "Tiệm đã ghé thăm"
    },
    "meta": {
      "title": "Tiệm đã ghé thăm",
      "description": "Danh sách các tiệm đã ghé thăm"
    }
  }
}
